import React, { useState, useEffect } from "react";
import { Layout } from "components";
import { ListGroup, Button } from "react-bootstrap";
import { getSubService } from "services/api-service";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { changeSubServiceInfo } from "redux/services";
import "../style.scss";
import { LinkButton, BackButton } from "components/CommonUI";
import { getService } from "services/api-service";
import { changeIconAndMainWebText } from "redux/services";

import { env } from "../env";

import { DEFAULT_ROUTE } from "constants/route";
import { getSeoText } from "utils/common";

const ZERO = 0;

export default function SubService() {
  const dispatch = useDispatch();
  const { icon, mainWebDisplayText } = useSelector((state) => state.services);
  const [subServiceList, setSubServiceList] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  const goHome = () => navigate(DEFAULT_ROUTE);

  const getSubServiceData = async () => {
    const { data: subService } = await getSubService(id);
    subService.data && setSubServiceList(subService.data);
  };

  useEffect(() => {
    getSubServiceData();
  }, []);

  useEffect(() => {
    // Re-fetch main service if its not in store,
    // might be coming from direct url
    if (!mainWebDisplayText && id) {
      getService().then(({ data: service }) => {
        const mainService = service.data.find((x) => x.id === parseInt(id, 10));
        dispatch(
          changeIconAndMainWebText({
            icon: mainService.icon_uuid,
            mainWebDisplayText: mainService.web_disp_text
          })
        );
      });
    }
  }, [mainWebDisplayText, id]);

  const goToDetail = (subServiceId, displayText, isCrps, isExperience) => {
    navigate(`/sub-service/${subServiceId}/${id}/${getSeoText(displayText)}`);
    dispatch(
      changeSubServiceInfo({
        mainId: id,
        subServiceId,
        displayText,
        isCrps,
        isExperience
      })
    );
  };

  return (
    <Layout subHeader={"How can we help?"}>
      <div className="form-box" style={{ marginTop: 20, marginBottom: 20 }}>
        <div className="d-flex justify-content-center align-items-center mt-3">
          {/* <img
            style={{ width: 50, height: 50, marginRight: "10px" }}
            alt="service icon"
            src={`${env.iconBaseUrl}${icon}`}
          /> */}
          <div className="icon-svc-sm">
            <i className={`icon-illustrative ${icon}`} aria-hidden="true"></i>
          </div>
          <div className="space-left d-md-flex d-md-flex-row d-sm-flex-column text-secondary">
            <div
              style={{ marginLeft: 15, fontWeight: 500 }}
              className="sub-header-label"
            >
              {mainWebDisplayText}
              {/* How can we help? */}
            </div>
            {/* <div>( Click to Select )</div> */}
          </div>
        </div>

        <div
          className="center row remove-margin"
          style={{ justifyContent: "center" }}
        >
          <ListGroup className="mt-3  col-md-8">
            {subServiceList.length !== ZERO ? (
              subServiceList.map(
                ({
                  id,
                  web_disp_text: displayText,
                  is_crps: isCrps,
                  is_experience: isExperience
                }) => (
                  <LinkButton
                    key={id}
                    text={displayText}
                    onClick={() =>
                      goToDetail(id, displayText, isCrps, isExperience)
                    }
                  />
                  // <ListGroup.Item
                  //   key={id}
                  //   className="p-2 border-1 m-1 list-hover"
                  //   onClick={() => goToDetail(id, displayText, isCrps)}
                  // >
                  //   {displayText}
                  // </ListGroup.Item>
                )
              )
            ) : (
              // <div>There is no data</div>
              <div></div>
            )}
          </ListGroup>

          <div className="form-footer">
            <BackButton />
          </div>
        </div>
      </div>
    </Layout>
  );
}
